import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=0c839907&scoped=true&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c839907",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c839907')) {
      api.createRecord('0c839907', component.options)
    } else {
      api.reload('0c839907', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=0c839907&scoped=true&", function () {
      api.rerender('0c839907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/tabs/tab.vue"
export default component.exports